/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Tooltip } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import React, { useState, useEffect } from 'react'
import { allSaleOffersSelector } from 'src/features'
import { AdminSaleOfferGroup } from 'src/core/models'
import styles from './AdminSaleOffersCard.module.scss'
import { CustomCard, CustomTable } from 'src/components'
import { getFilteredOfferSaleGroups } from 'src/core/helpers'
import { saleOfferGroupColumns } from 'src/core/table-columns'
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import AdminSaleOffersGroupList from './AdminSaleOffersGroupList/AdminSaleOffersGroupList'
import OfferGroupSaleOfferHeader from './OfferGroupSaleOfferHeader/OfferGroupSaleOfferHeader'

const AdminSaleOffersCard: React.FC = () => {
  const { t } = useTranslation()
  const { loading, data } = useAppSelector(allSaleOffersSelector)
  const [filterText, setFilterText] = useState<string>(null)
  const [filteredGroups, setFilteredGroups] = useState<AdminSaleOfferGroup[]>(data)

  useEffect(() => { if (data.length > 0) setFilteredGroups(data) }, [data])

  useEffect(() => {
    const newFilteredGroups = getFilteredOfferSaleGroups(filterText, data)
    setFilteredGroups(newFilteredGroups)
  }, [filterText])

  const tableProps = {
    dataSource: filteredGroups,
    columns: saleOfferGroupColumns,
    rowKey: (item: AdminSaleOfferGroup) => item.id,
    expandable: {
      expandedRowRender: (group: AdminSaleOfferGroup) => <AdminSaleOffersGroupList group={group} />,
      expandRowByClick: true,
    },
    rowClassName: (group: AdminSaleOfferGroup) => {
      return group?.sale_offers?.length === 0 ? 'is-content-disabled' : 'fade-animation'
    },
    expandIcon: ({ expanded, onExpand, record }) => {
      return expanded ? <DownOutlined onClick={e => onExpand(record, e)} /> : (
        <Tooltip title={t('SalesOffer.Check')} color={'blue'}>
          <RightOutlined onClick={e => onExpand(record, e)} />
        </Tooltip>
      )
    }
  }

  return (
    <CustomCard
      className={'mt-4'}
      loading={loading}
    >
      <OfferGroupSaleOfferHeader
        filterText={filterText}
        handleChange={(value) => setFilterText(value)}
        length={filteredGroups?.length || 0}
      />

      <Divider className={styles.divider} />
      <CustomTable {...tableProps} />
    </CustomCard>
  )
}

export default AdminSaleOffersCard
